<template>
  <TContainer>
    <MenuBreadcrumb />
  </TContainer>
</template>
